export default __webpack_public_path__ + "static/media/polygon.d88b8c4e.svg";